import { render, staticRenderFns } from "./EDataFailed.vue?vue&type=template&id=702d4f2d&"
import script from "./EDataFailed.vue?vue&type=script&lang=js&"
export * from "./EDataFailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports